import React from 'react';
import { Modal, Container, Row, Col } from 'reactstrap';
// import { Modal } from 'reactstrap';
// import { Form, FormGroup, Label } from 'reactstrap';

import { withNamespaces } from 'react-i18next';

import { ApiContext } from 'src/utils/ApiContext';

export default withNamespaces()(ModalBindSelect);
function ModalBindSelect(props) {
  // const { onClickBindMatchPay, onSelectLink } = props;
  const { onClickBindMatchPay } = props;
  // const { t } = props;

  const context = React.useContext(ApiContext);
  // const widRef = React.createRef();

  return (
    <Modal
      isOpen={context.showBindSelect}
      toggle={() => context.setShowBindSelect(false)}
      zIndex={1}
    >
      <Container style={{ padding: 20, background: '#1E3845' }}>
        <Row className={'justify-content-center align-items-center'}>
          <div style={{ color: 'whitesmoke' }}>{'請選擇綁定的方式'}</div>
        </Row>

        <Row className={'justify-content-center align-items-center'}>
          <Col xs={3}>
            <button
              className={'btn btn-outline-success my-2'}
              onClick={() => {
                onClickBindMatchPay();
                context.setShowBindSelect(false);
              }}
            >
              E Pay
            </button>
          </Col>
          {/* <Col xs={4}>
            <button
              className={'btn btn-outline-info my-2'}
              onClick={() => {
                onSelectLink();
                context.setShowBindSelect(false);
              }}
            >
              綁定頁面
            </button>
          </Col> */}
        </Row>
      </Container>
      {/* <Form style={{ padding: 20 }}>
        <FormGroup>
          <Label for={'register-wid'}>{t('ModalBindSelect.PayLoginAccount')}</Label>
          <input
            ref={widRef}
            type={'text'}
            pattern={'^[a-z0-9A-Z]{1,64}$'}
            name={'wid'}
            maxLength={200}
            id={'register-wid'}
            placeholder={t('ModalBindSelect.PleaseEnterYourPayAccount')}
            style={{ width: '100%' }}
          />
        </FormGroup>
        <button
          className={'btn btn-outline-success my-2'}
          onClick={() => {
            onClickBindMatchPay(widRef.current.value);
            context.setShowBindSelect(false);
          }}
        >
          {t('ModalBindSelect.Bind')}
        </button>
      </Form> */}
    </Modal>
  );
};
